import clsx from 'clsx';

const htmlTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span', 'b', 'strong', 'i', 'em', 'ol', 'ul', 'li'] as const;
type HtmlTag = (typeof htmlTags)[number];
type LooksLike =
    | Exclude<HtmlTag, 'span' | 'b' | 'strong' | 'i' | 'em'>
    | 'pLarge'
    | 'pSmall'
    | 'label'
    | 'menu'
    | 'tag';

interface TextProps {
    children: React.ReactNode;
    as?: HtmlTag;
    looksLike?: LooksLike;
    className?: string;
    style?: React.CSSProperties;
}

export const Typography: React.FC<TextProps> = ({ children, className, as = 'p', looksLike, ...props }) => {
    const Tag = as;

    return (
        <Tag
            className={clsx(looksLike, className)}
            {...props}
        >
            {children}
        </Tag>
    );
};
